module.exports = __webpack_public_path__ + "media/images/mobile/solutions/16-710c86788a95d270ba019c02d5df30f3.png";